import React, { useEffect, useRef } from "react";
import Modal from "@mui/material/Modal";
import utsavModalClasses from "../styles/utsavModal.module.css";
import { Typography } from "@mui/material";

export default function UtsavModal({
  heading,
  message,
  open,
  toggleModal,
  acceptMsg,
  rejectMsg,
  onAccept,
  positive = true,
}) {
  let [processing, setProcessing] = React.useState(false);
  const ref = useRef();
  useEffect(() => {
    if (open) {
      window.addEventListener("keypress", acceptOnKey);
      return () => {
        window.removeEventListener("keypress", acceptOnKey);
      };
    }

    // eslint-disable-next-line
  }, [open]);

  useEffect(() => {
    if (open) {
      window.addEventListener("mousedown", onClickHandler);
      return () => {
        window.removeEventListener("mousedown", onClickHandler);
      };
    }
    // eslint-disable-next-line
  }, [open]);

  const acceptOnKey = (e) => {
    if (e.key === "Enter") {
      onAccept ? onAccept() : toggleModal();
    }
  };

  function onClickHandler(e) {
    if (ref.current && e.target) {
      const res = ref.current.contains(e.target);
      if (!res) toggleModal();
    }
  }

  return (
    <Modal open={open} onClose={toggleModal}>
      <div className={utsavModalClasses.modalOver}>
        <div ref={ref} className={utsavModalClasses.modalCard}>
          <div className={utsavModalClasses.modalCard__head}>
            {heading && (
              <Typography className={utsavModalClasses.modalCard__heading}>
                {heading}
              </Typography>
            )}
            {message && (
              <div className={utsavModalClasses.modalCard__msg}>{message}</div>
            )}
          </div>
          {!positive ? (
            <div className={utsavModalClasses.modalCard__options}>
              {acceptMsg && (
                <button
                  className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_neg}`}
                  onClick={
                    onAccept
                      ? (e) => {
                          setProcessing((processing = true));
                          onAccept(setProcessing);
                          setTimeout(() => {
                            setProcessing(false);
                          }, 10000);
                        }
                      : toggleModal
                  }
                >
                  {processing ? (
                    <div className={utsavModalClasses.logoutWithLoader}>
                      <div
                        className={`${utsavModalClasses.loader}`}
                        id={`${utsavModalClasses.loader}`}
                      ></div>{" "}
                    </div>
                  ) : (
                    acceptMsg
                  )}
                </button>
              )}
              {rejectMsg && (
                <button
                  className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_pos}`}
                  onClick={toggleModal}
                >
                  {rejectMsg}
                </button>
              )}
            </div>
          ) : (
            <div className={utsavModalClasses.modalCard__options}>
              {rejectMsg && (
                <button
                  className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_neg}`}
                  onClick={toggleModal}
                >
                  {rejectMsg}
                </button>
              )}
              {acceptMsg && (
                <button
                  className={`${utsavModalClasses.modalCard__btn} ${utsavModalClasses.modalCard__btn_pos}`}
                  onClick={
                    onAccept
                      ? (e) => {
                          setProcessing((processing = true));
                          onAccept(setProcessing);
                          setTimeout(() => {
                            setProcessing(false);
                          }, 10000);
                        }
                      : toggleModal
                  }
                >
                  {processing ? (
                    <div className={utsavModalClasses.logoutWithLoader}>
                      <div
                        className={`${utsavModalClasses.loader}`}
                        id={`${utsavModalClasses.loader}`}
                      ></div>{" "}
                    </div>
                  ) : (
                    acceptMsg
                  )}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
